import React, { useState } from "react";
import Context from "./Index";
import { LinksApi, SUCCESS_API_RESPONSE } from "../../../Shared/Constants/api";
import { errorGettingData, genericError } from "../../../Shared/Constants";
import { alertToastErrorFromResponse } from "../../../Shared/Utils/errorUtils";
import { alertError } from "../../../Shared/Utils/alertMessages";
import { getCall } from "../../../Shared/Api/GetApi";

export default function LinksProvider(props) {
  const [showModal, setShowModal] = useState(false);

  const modalTogle = () => {
    setShowModal(!showModal);
  };

  const [items, setItems] = useState([]);
  const [item, setItem] = useState([]);
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  /**
   * Get a list of items
   * @param {*} page
   * @param {*} limit
   */
  const fetchItems = async (page, limit) => {
    setLoading(true);
    try {
      let response = await getCall(LinksApi, {
        page: page,
        limit: limit,
        ...filters,
      });
      let data = response.data;
      if (response.result === SUCCESS_API_RESPONSE) {
        //setItems((prevItems) => [...prevItems, ...data.items]);
        setItems(data.items);
        setTotalRows(data.totalRows); // Append new data
      } else {
        setTotalRows(0); // Append new data
        alertToastErrorFromResponse(errorGettingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Context.Provider
      value={{
        ...props,
        fetchItems,
        items,
        rowsPerPage,
        currentPage,
        setCurrentPage,
        item,
        setItem,
        loading,
        saving,
        showModal,
        modalTogle,
        setShowModal,
        setFilters,
        filters,
        setItems,
      }}
    >
      {props.children}
    </Context.Provider>
  );
}
